<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()" [disabled]="purchasing || paymentProcessing">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="upgradeTrial">{{ 'ACCOUNTS.premium.lbl.account_upgrade' | translate }}</ng-container>
      <ng-container *ngIf="!upgradeTrial">{{ 'ACCOUNTS.premium.lbl.go_premium' | translate }}</ng-container>
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="ion-no-padding">
    <div class="header-div content-div vertical-center ion-padding">
      <div class="ion-padding">
        <ion-text color="white">
          <ng-container *ngIf="trialExpired then trial_expired"></ng-container>
          <ng-container *ngIf="upgradeTrial then trial_upgrade"></ng-container>
          <ng-container *ngIf="!trialExpired && !upgradeTrial then subscribe"></ng-container>
        </ion-text>
        
        <ion-card class="header-card full-width">
          <!-- promo-div  -->
          <div class="ion-padding ion-margin" *ngIf="iapMode && product?.id && price?.currency && price.amount">
            <div class="ion-text-center">
              <!-- <ion-text class="font-14 font-med" [innerHTML]="'ACCOUNTS.premium.msg.get_product' | translate: { product: product?.title ? product.title : 'PRODUCT.account.title' | translate }"></ion-text> -->
              <div>
                <div><ion-text class="font-16 font-bold" color="danger" *ngIf="sellingPrice">{{ sellingPrice.amount | currency: sellingPrice.currency: 'symbol' }} </ion-text></div>
                <div><ion-text class="font-20 font-bold original-price" color="white" *ngIf="originalPrice"> {{ originalPrice.amount | currency: originalPrice.currency: 'symbol' }} </ion-text></div>
                <div><ion-text class="unit font-10" color="white"> {{ 'PRODUCT.account.per_wedding' | translate }}</ion-text></div>
              </div>        
            </div>
            <!-- <div class="ion-text-center">
              <ion-text class="font-12 ion-text-uppercase" *ngIf="!product?.description" [innerHTML]="'ACCOUNTS.premium.msg.one_time_purchase' | translate"></ion-text>
              <ion-text class="font-12 ion-text-uppercase" *ngIf="product?.description" [innerHTML]="product?.description"></ion-text>
            </div> -->
          </div>

        </ion-card>
        <!-- <div class="btn-div">
          <ion-button expand="block" (click)="goProductAccountPage()" *ngIf="!product || (!iapMode || !product?.id)">
            {{ 'ACCOUNTS.premium.lbl.go_premium'| translate }}
          </ion-button>
          <div *ngIf="iapMode && product?.id">
            <ion-button expand="block" (click)="checkUserLogin(product)" [disabled]="purchasing || paymentProcessing">
              {{ 'IAP.title'| translate }}<ion-spinner class="spinner" name="dots" *ngIf="paymentProcessing"></ion-spinner>
            </ion-button>
          </div>
          <div class="ion-text-center" (click)="switchIap()" *ngIf="product?.id && android && checkIap">
            <ion-text class="font-12 font-underline">{{ (iapMode ? 'IAP.msg.switch_stripe' : 'IAP.msg.switch_iap') | translate }}</ion-text>
          </div>
        </div> -->
      </div>
      
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="content-div">
    <ion-card class="feature-card" color="white" *ngIf="specialPromoVoucher?.blastCredit">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/free_credit.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.free_credit.title' | translate: { credit: specialPromoVoucher?.blastCredit } }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.free_credit.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>
    
    <ion-card class="feature-card" color="white">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/premium_feature.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.premium_feature.title' | translate }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.premium_feature.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>
    
    <ion-card class="feature-card" color="white">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/14day_guarantee.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.14day_guarantee.title' | translate }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.14day_guarantee.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>

    <ion-card class="feature-card" color="white">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/early_access.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.early_access.title' | translate }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.early_access.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>
    
    <ion-card class="feature-card" color="white">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/ad_free.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.ad_free.title' | translate }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.ad_free.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>
    
    <ion-card class="feature-card" color="white">
      <ion-item class="feature-item ion-item-no-padding" lines="none" shape="round" color="white">
        <ion-card class="ion-card vertical-center" color="secondary" slot="start">
          <ion-icon class="font-24 center" src="./assets/wedding/icon/subscription/priority_support.svg"></ion-icon>
        </ion-card>
        
        <ion-text>
          <div><ion-text class="font-14 font-bold">{{ 'ACCOUNTS.premium.msg.priority_support.title' | translate }}</ion-text></div>
          <div class="line-1"><ion-text class="font-12 line-1">{{ 'ACCOUNTS.premium.msg.priority_support.msg' | translate }}</ion-text></div>
        </ion-text>
      </ion-item>
    </ion-card>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion-padding-horizontal" color="white">
    <div class="content-div">
      <ion-button expand="block" (click)="goProductAccountPage()" *ngIf="!product || (!iapMode || !product?.id)">
        {{ 'ACCOUNTS.premium.lbl.go_premium'| translate }}
      </ion-button>
      <div *ngIf="iapMode && product?.id">
        <ion-button expand="block" (click)="checkUserLogin(product)" [disabled]="purchasing || paymentProcessing">
          {{ 'IAP.title'| translate }}<ion-spinner class="spinner" name="dots" *ngIf="paymentProcessing"></ion-spinner>
        </ion-button>
      </div>
      <div class="ion-text-center" (click)="switchIap()" *ngIf="product?.id && android && checkIap">
        <ion-text class="font-12 font-underline">{{ (iapMode ? 'IAP.msg.switch_stripe' : 'IAP.msg.switch_iap') | translate }}</ion-text>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>

<!-- <ion-header>
  <ion-toolbar [class]="'header-' + specialPromoVoucherId" [color]="!specialPromoVoucherId ? 'primary' : ''">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()" [disabled]="purchasing || paymentProcessing">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="upgradeTrial">{{ 'ACCOUNTS.premium.lbl.account_upgrade' | translate }}</ng-container>
      <ng-container *ngIf="!upgradeTrial">{{ 'ACCOUNTS.premium.lbl.go_premium' | translate }}</ng-container>
    </ion-title>
  </ion-toolbar>
</ion-header> -->

<!-- <ion-content>
  <div class="content-div">
    <ng-container *ngIf="specialPromoVoucherId else normal_promo">
      <ion-item class="ion-item-no-padding background-transparent" [class]="'card-' + specialPromoVoucherId" [color]="specialPromoVoucherId === 'SMS' ? 'primary' : specialPromoVoucherId === 'Valentine2023' ? '' : ''" lines="none" *ngIf="specialPromoVoucherId">
        <ion-label class="ion-no-margin">
          <ng-container *ngIf="specialPromoVoucherId === 'FebPayDay23'">
            <div class="ion-margin-vertical">
              <ion-img class="payday-title full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/title_' + language + '.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical">
              <ion-img class="payday-img full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/main.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical">
              <ion-img class="payday-msg full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/msg_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === '03032023'">
            <div class="ion-margin-vertical">
              <ion-img class="threethree-img center" [src]="'./assets/wedding/img/news/promo/03032023/banner_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'WomensDay23'">
            <div class="ion-margin-vertical">
              <ion-img class="womensday-title full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/title_' + language + '.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical">
              <ion-img class="womensday-img full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/main.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical">
              <ion-img class="womensday-msg full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/msg_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Valentine2023'">
            <div>
              <ion-img class="valentine-ballons full-width center" [src]="'./assets/wedding/img/news/promo/valentine/ballons.svg'"></ion-img>
            </div>
            <div>
              <ion-img class="sms-promo-title full-width center" [src]="'./assets/wedding/img/news/promo/valentine/title_' + language + '.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical ion-padding-top">
              <ion-img class="sms-promo-msg full-width center" [src]="'./assets/wedding/img/news/promo/valentine/msg_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MarPayDay23'">
            <div class="ion-margin-vertical ion-padding-vertical">
              <ion-img class="full-width center" [ngClass]="'title-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/title_' + language + '.svg'"></ion-img>
            </div>
            <div>
              <ion-img class="full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/main.svg'"></ion-img>
            </div>
            <div class="ion-margin-vertical ion-padding-vertical">
              <ion-img class="full-width center" [ngClass]="'msg-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/msg_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === '04042023'">
            <div class="ion-margin-bottom">
              <ion-img class="full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/04042023/iap_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Easter23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Easter23/iap_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Ramadan23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Ramadan23/iap_' + language + '.svg'"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'LabourDay23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/LabourDay23/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === '05052023'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/05052023/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MotherDay23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/MotherDay23/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === '5202023'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/5202023/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MayPayDay23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/MayPayDay23/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'DragonBoat23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'FatherDay23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Haji23'">
            <div class="ion-margin-bottom ion-padding-bottom">
              <ion-img class="promo-img full-width center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/June/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          
          <ng-container *ngIf="specialPromoVoucherId === '07072023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MidYear2023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Summer2023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/July/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'SG58th'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'SurpriseAug23'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Merdeka66th'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          
          <ng-container *ngIf="specialPromoVoucherId === '09092023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MalaysiaDay2023'">
            <div>
              <ion-img class="promo-img center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'MidAutumn23'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === '10102023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Halloween2023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === '11112023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'BlackFriday2023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === '12122023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Christmas2023'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'Year2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jan/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'JanPayDay24'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jan/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'CNY2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Feb/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'FebPayDay24'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Feb/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
  
          <ng-container *ngIf="specialPromoVoucherId === 'WomensDay2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Mar/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
          <ng-container *ngIf="specialPromoVoucherId === 'Ramadan2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Mar/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === '04042024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Apr/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'Raya2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Apr/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'MothersDay2024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === '5202024'">
            <div>
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/May/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === '06062024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jun/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === 'Haji2024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jun/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === '07072024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jul/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === 'MidYearSale24'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Jul/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'TogetherSG59'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'Merdeka67th'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === '09092024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === 'MalaysiaDay2024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
    
          <ng-container *ngIf="specialPromoVoucherId === '10102024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
          <ng-container *ngIf="specialPromoVoucherId === 'Halloween2024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>

          <ng-container *ngIf="specialPromoVoucherId === '11112024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>

          <ng-container *ngIf="specialPromoVoucherId === 'BlackFriday2024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + specialPromoVoucherId + '/iap_' + language + '.png'" slot="start"></ion-img>
            </div>
          </ng-container>

          <ng-container *ngIf="specialPromoVoucherId === '12122024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>

          <ng-container *ngIf="specialPromoVoucherId === 'Christmas2024'">
            <div class="banner-div">
              <ion-img class="promo-img width-90 center" [ngClass]="'img-' + specialPromoVoucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + specialPromoVoucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
            </div>
          </ng-container>
  
        </ion-label>
      </ion-item>
    </ng-container>
    <ng-template #normal_promo>
      <ion-img class="img center" src="./assets/wedding/img/subscription/premium.svg"></ion-img>
    </ng-template>
    
    <div class="ion-padding-horizontal">
      <ng-container *ngIf="trialExpired then trial_expired"></ng-container>
      <ng-container *ngIf="upgradeTrial then trial_upgrade"></ng-container>
      <ng-container *ngIf="!trialExpired && !upgradeTrial then subscribe"></ng-container>
  
      <div class="why-div font-18 font-med ion-text-center ion-margin ion-padding-vertical">
        <div>{{ 'ACCOUNTS.premium.lbl.why_premium' | translate }}</div>
      </div>
  
      <div class="promo-div ion-padding ion-margin" *ngIf="iapMode && product?.id && price?.currency && price.amount">
        <div class="ion-text-center">
          <ion-text class="font-14 font-med" [innerHTML]="'ACCOUNTS.premium.msg.get_product' | translate: { product: product?.title ? product.title : 'PRODUCT.account.title' | translate }"></ion-text>
          <div>
            <ion-text class="font-12 font-med" color="danger" *ngIf="sellingPrice">{{ sellingPrice.amount | currency: sellingPrice.currency: 'symbol' }} </ion-text>
            <ion-text class="font-14 font-med strikethrough" *ngIf="originalPrice"> {{ originalPrice.amount | currency: originalPrice.currency: 'symbol' }} </ion-text>
            <ion-text class="unit font-8"> {{ 'PRODUCT.account.per_wedding' | translate }}</ion-text>
          </div>        
        </div>
        <div class="ion-text-center">
          <ion-text class="font-12 ion-text-uppercase" *ngIf="!product?.description" [innerHTML]="'ACCOUNTS.premium.msg.one_time_purchase' | translate"></ion-text>
          <ion-text class="font-12 ion-text-uppercase" *ngIf="product?.description" [innerHTML]="product?.description"></ion-text>
        </div>
      </div>
  
      <div class="ion-margin">
        <ion-grid class="full-width font-12" fixed>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.premium.msg.unlimited_guest' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.premium.msg.unlimited_device' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ng-container *ngIf="specialPromoVoucher">
            <ion-row *ngIf="specialPromoVoucher?.blastCredit">
              <ion-col size="auto">
                <ng-container *ngIf="true then circleCheckMark"></ng-container>
              </ion-col>
              <ion-col>
                <ion-text [innerHTML]="'BLAST.promo.iap' | translate: { blastCredit: (specialPromoVoucher.blastCredit | number) }"></ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.premium.msg.offline' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.premium.msg.platform' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.premium.msg.sync' | translate"></ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="content-div ion-padding">
      <ion-button [ngClass]="'btn-' + specialPromoVoucherId" expand="block" (click)="goProductAccountPage()" *ngIf="!product || (!iapMode || !product?.id)">
        {{ 'ACCOUNTS.premium.lbl.go_premium'| translate }}
      </ion-button>
      <div *ngIf="iapMode && product?.id">

        <ion-button [ngClass]="'btn-' + specialPromoVoucherId" expand="block" (click)="checkUserLogin(product)" [disabled]="purchasing || paymentProcessing">
          {{ 'IAP.title'| translate }}<ion-spinner class="spinner" name="dots" *ngIf="paymentProcessing"></ion-spinner>
        </ion-button>

      </div>
      <div class="ion-text-center" (click)="switchIap()" *ngIf="product?.id && android && checkIap">
        <ion-text class="font-12 font-underline">{{ (iapMode ? 'IAP.msg.switch_stripe' : 'IAP.msg.switch_iap') | translate }}</ion-text>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>

<ng-template #circleCheckMark>
  <div class="icon-div"><ion-icon class="icon-small" name="checkmark-circle" color="success"></ion-icon></div>
</ng-template> -->

<ng-template #trial_expired>
  <div class="font-20 font-bold ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.trial_expired.intro_title' | translate }}
  </div>

  <div class="font-14 ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.trial_expired.intro_msg' | translate }}
  </div>
</ng-template>

<ng-template #trial_upgrade>
  <div class="font-20 font-bold ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.trial_upgrade.intro_title' | translate }}
  </div>

  <div class="font-14 ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.trial_upgrade.intro_msg' | translate }}
  </div>
</ng-template>

<ng-template #subscribe>
  <div class="font-20 font-bold ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.subscribe.intro_title' | translate }}
  </div>

  <div class="font-14 ion-text-center ion-margin">
    {{ 'ACCOUNTS.premium.subscribe.intro_msg' | translate }}
  </div>
</ng-template>